"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentProfilePageReducer = void 0;
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var RootPublicPageReducer_1 = require("@/pages/common/reducers/RootPublicPageReducer");
var AgentProfileReducer_1 = require("@/pages/agentProfile/reducers/AgentProfileReducer");
var BreadcrumbReducer_1 = require("@/pages/search/reducers/BreadcrumbReducer");
exports.agentProfilePageReducer = {
    page: function (state) {
        if (state === void 0) { state = Pages_1.Pages.AGENT_PROFILE; }
        return state;
    },
    breadcrumb: BreadcrumbReducer_1.breadcrumbReducer,
    agentProfile: AgentProfileReducer_1.agentProfileReducer,
};
var combinedReducer = redux_1.combineReducers(__assign(__assign({}, RootPublicPageReducer_1.default), exports.agentProfilePageReducer));
var rootAgentProfileReducer = function (state, action) {
    if (action.type === 'SET_ALL_STATE_AGENT_PROFILE') {
        return __assign(__assign({}, state), action.payload);
    }
    return combinedReducer(state, action);
};
exports.default = rootAgentProfileReducer;
